import React from "react";
import PropTypes from "prop-types";
import classNames from "../../../utils/classNames";
import "./index.scss";

const ClearIcon = () => (
    <svg
        viewBox="0 0 24 24"
        fill="none"
        stroke="currentColor"
        strokeWidth="2.4"
        strokeLinecap="round"
        aria-hidden="true"
        focusable="false"
    >
        <path d="M6 6l12 12M18 6 6 18" />
    </svg>
);

/**
 * Small circular X button used to clear the value of a single field
 * (search pill, dropdown trigger, text input). Distinct from CloseButton
 * (which dismisses modals/popovers) — semantics and default sizing differ.
 *
 * Drop into any glass/pill input and pass `onClick` to clear the value.
 * The button is purely visual; callers control when it's mounted.
 */
const ClearButton = React.forwardRef(function ClearButton({
    onClick,
    ariaLabel,
    size = "sm",
    className = "",
    ...rest
}, ref) {
    return (
        <button
            ref={ref}
            type="button"
            className={classNames("clear-button", `clear-button--${size}`, className)}
            onClick={onClick}
            aria-label={ariaLabel}
            {...rest}
        >
            <ClearIcon />
        </button>
    );
});

ClearButton.propTypes = {
    onClick: PropTypes.func.isRequired,
    ariaLabel: PropTypes.string.isRequired,
    size: PropTypes.oneOf(["xs", "sm", "md"]),
    className: PropTypes.string,
};

export default ClearButton;
